// to push custom events
export function push(args) {
	if (!window._mtm) {
		window._mtm = [];
	}
	window._mtm.push(args);
}
